import { Box, Stack, UnstyledButton } from "@mantine/core";
import {
  IconBellMinus,
  IconHeartRateMonitor,
  IconLogout,
  IconCalendarEventFilled,
} from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router";
import classes from "./index.module.scss";

const navItems = [
  { label: "Monitors", icon: IconHeartRateMonitor, path: "monitor" },
  { label: "Alerts", icon: IconBellMinus, path: "alerts" },
];

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Box className={classes.sidebar}>
      <Stack className={classes.menu}>
        {navItems.map((item) => {
          const isActive = location.pathname.includes(item.path);
          return (
            <UnstyledButton
              key={item.label}
              className={`${classes.link} ${isActive ? classes.active : ""}`}
              onClick={() => navigate(item.path)}
            >
              <item.icon className={classes.icon} size={20} />
              <span>{item.label}</span>
            </UnstyledButton>
          );
        })}
      </Stack>

      {/* 底部退出 */}
      <Box className={classes.footer}>
        <Stack className={classes.menu} mb={10}>
          <UnstyledButton
            className={`${classes.settings}`}
            onClick={() => (window.location.href = "/app/pricing")}
          >
            <IconCalendarEventFilled className={classes.icon} />
            <span>Subscription</span>
          </UnstyledButton>
        </Stack>
        <Stack className={classes.menu}>
          <UnstyledButton
            className={`${classes.settings} ${
              location.pathname.includes("settings") ? classes.active : ""
            }`}
            onClick={() => navigate("/settings")}
          >
            <IconLogout className={classes.icon} />
            <span>Setings</span>
          </UnstyledButton>
        </Stack>
      </Box>
    </Box>
  );
};
